import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';

/** `/reference` (1.AB-2): the layout of the reference page and shelf, guarded as `/` is. */
export const Route = createFileRoute('/reference')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Reference' },
  component: Outlet,
});
